
<template>

    <section id="aboutPage">

        <div class="row">

            <div class="col-12 col-md-8 offset-md-2">

                <section class="content">

                    <h1>{{ page.title }}</h1>
                    <div class="divider-image divider-image-2"></div>

                    <section class="custom-text mb-4 mt-5" :class="{'editor-active': edit}">
                        <froala v-if="edit" :tag="'textarea'" :config="froalaConfig" v-model="itemEditText"></froala>
                        <div v-else v-html="page.content"></div>

                        <section class="authors mt-5">

                            <h2>Authors</h2>
                            <hr class="mb-5">

                            <div class="mb-5 author" v-for="author in authors">

                                <div class="row">
                                    <div class="col-12 col-sm-5">
                                        <img class="profile-image img-fluid" :src="displayImage(author.image, 400)" :alt="'Image of: ' + author.name">

                                        <div v-if="author.contact">
                                            <ul class="contact-list list-unstyled list-inline">
                                                <li v-if="author.contact.email"><a :href="'mailto:'+author.contact.email"><i class="fal fa-envelope"></i></a></li>
                                                <li v-if="author.contact.facebook"><a :href="author.contact.facebook"><i class="fab fa-facebook"></i></a></li>
                                                <li v-if="author.contact.instagram"><a :href="author.contact.instagram"><i class="fab fa-instagram"></i></a></li>
                                                <li v-if="author.contact.pinterest"><a :href="author.contact.pinterest"><i class="fab fa-pinterest"></i></a></li>
                                                <li v-if="author.contact.youtube"><a :href="author.contact.youtube"><i class="fab fa-youtube"></i></a></li>
                                                <li v-if="author.contact.twitter"><a :href="author.contact.twitter"><i class="fab fa-twitter"></i></a></li>
                                                <li v-if="author.contact.website"><a :href="author.contact.website"><i class="fal fa-globe"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-7">
                                        <h3>{{author.name}}</h3>
                                        <div class="description" v-html="author.description"></div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    </section>

                </section>
            </div>
        </div>

    </section>

</template>

<script>
    import VueFroala from 'vue-froala-wysiwyg';

    export default {
        data () {
            return {
                edit: false,
                froalaConfig: {

                    // Image upload
                    imageUploadParam: "image",
                    imageUploadURL: window.cms + 'image/uploadFroala',
                    imageMaxSize: 50 * 1024 * 1024,
                    imageUploadMethod: 'POST',

                    // Video upload
                    videoUploadParam: "video",
                    videoUploadURL: window.cms + 'video/uploadFroala',
                    videoUploadMethod: 'POST',
                    videoMaxSize: 50 * 1024 * 1024,

                    // Video upload
                    fileUploadParam: "file",
                    fileUploadURL: window.cms + 'upload/uploadFroala',
                    fileUploadMethod: 'POST',
                    fileMaxSize: 200 * 1024 * 1024,

                    editorClass: 'text mb-4 mt-4',
                    charCounterCount: false,
                    toolbarInline: true,
                    toolbarButtons: ['undo', 'redo', 'bold', 'italic', 'underline', 'strikeThrough', '|', 'fontSize', 'color', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'specialCharacters', 'insertHR', 'clearFormatting', '|', 'print', 'html'],
                    videoEditButtons: ['videoRemove', 'videoSize'],
                    imageStyles: {
                        wide: 'Wide image',
                        pleft: 'Pull image left',
                        pright: 'Pull image right',
                    },
                    imageEditButtons: ['imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', 'imageStyle', 'imageSize'],
                    events: {
                        'froalaEditor.contentChanged': function (e, editor) {

                            clearTimeout(window.editorDebounce);
                            window.editorDebounce = setTimeout(function() {

                                jQuery.ajax({
                                    url: window.cms + "page/updateUnsavedContent/"+window.currentItemId,
                                    type: "put",
                                    data: {
                                        unsaved_content: editor.html.get()
                                    }
                                }).fail(function (data) {

                                    console.log(data.responseText);
                                });

                            }, 900);
                        },
                        "froalaEditor.image.error": function(e, editor, error, response) {

                            console.log(error);
                            console.log(response);
                        }
                    },
                },
                itemEditText: "",
                authors: []
            }
        },
        props: ["page"],
        created: function() {
        },
        methods: {

            displayImage: function(image, width, height) {

                if(!image) return "";

                return window.cms + image.display +
                    (width !== null && typeof width !== "undefined" && !isNaN(width) ? "?w=" + width : "") +
                    (height !== null && typeof height !== "undefined" && !isNaN(height) ?
                        (width !== null && typeof width !== "undefined" && !isNaN(width) ? "&" : "?") + "h=" + height : "");
            },

            sloDate: function(date) {

                // 15th february 2018
                return moment(date).format("Do MMMM YYYY");
            },

        },
        mounted: function() {

            let handle = this;

            jQuery(document).ready(function() {

                jQuery.ajax({
                    url: window.cms + "author",
                    type: "get",
                    dataType: "json",
                    success: function(data) {

                        console.log("data");
                        console.log(data);

                        handle.authors = data;
                    }
                }).fail(function(error) {

                    console.log("Error getting blog");
                    console.log(error);
                    console.log(error.responseText);
                });
            });

            if(getParameterByName("edit")) {

                handle.edit = true;
                handle.itemEditText = (handle.page.unsaved_content === null || typeof handle.page.unsaved_content === "undefined" || handle.page.unsaved_content.length === 0 ? handle.page.content : handle.page.unsaved_content);
            }

            if(getParameterByName("preview") && handle.page.unsaved_content !== null && handle.page.unsaved_content.length !== 0) {

                handle.page.content = handle.page.unsaved_content;
            }
        }
    }

</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/pages/custom/About.vue